<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="small"
        @click="$refs.dialogCreate.toggleActive(true)"
      >Tambah Kategori Agenda</vs-button>
      <h3>Manajemen Kategori Agenda</h3> <br>
      <div class="w-full flex justify-end">
        <div>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            placeholder="Cari"
            v-model="search"
          />
        </div>
      </div>
      <global-wrapper
        :loading="$apollo.queries.kategoriAgenda.loading"
        :loadingType="'TwoLine'"
        :loadingList="5"
        :empty="kategoriAgenda.data.length <= 0"
        :error="error"
      >
        <global-table 
          @reloadData="handleOnReloadPage($event)" 
          :currentPage="paginationPage" 
          :totalPage="kategoriAgenda.paginatorInfo.lastPage"
        >
          <template #thead>
            <global-th widglobal-th="20px" left="0" class="sticky-col"
              >No.</global-th>
            <global-th>Nama</global-th>
            <global-th>Warna</global-th>
            <global-th>Deskripsi</global-th>
            <global-th>Action</global-th>
          </template>
          <template #tbody>
            <global-tr v-for="(item, index) in kategoriAgenda.data" :key="index">
              <global-td width="20px" left="0" class="sticky-col">
                {{ Math.ceil((kategoriAgenda.paginatorInfo.currentPage-1) * kategoriAgenda.paginatorInfo.perPage + index + 1) }}
              </global-td>
              <global-td>{{item.nama}}</global-td>
              <global-td>
                  <vs-chip :color="item.warna"
                    class="product-order-status"
                  >&emsp;&emsp;&emsp;&emsp;</vs-chip>
              </global-td>
              <global-td width="40%">{{item.deskripsi}}</global-td>
              <global-td>
                <div class="vx-row">
                  <vs-button
                    @click="setUpdateItem(index)"
                    color="primary"
                    size="small"
                    class="m-1"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                  >Update Data</vs-button>
                </div>
              </global-td>
            </global-tr>
          </template>
        </global-table>
      </global-wrapper>
      <DialogCreate
        ref="dialogCreate"
        @submitCallback="handleOnReloadPage(1)"
      />
      <DialogUpdate
        ref="dialogUpdate"
        :kategoriAgenda="selectedUpdateItem"
        @submitCallback="handleOnReloadPage(1)"
      />
    </div>
  </div>
</template>

<script>
import {GET_ALL as ALL_KATEGORI_AGENDA} from '@/query/kategori-agenda';
import vSelect from "vue-select";
import DialogCreate from "./DialogCreate";
import DialogUpdate from "./DialogUpdate";
import _ from "lodash";

export default {
  components : {
    "v-select": vSelect,
    DialogCreate,
    DialogUpdate
  },
  data() {
    return {
      kategoriAgenda: {
        data: [],
        paginatorInfo: {
          lastPage : 1,
          currentPage: 1
        }
      },
      error: false,
      paginationPage: 1,
      search: '',
      selectedUpdateItem: {}
    };
  },
  watch : {
    search: {
      handler(){
        this.refetchKategoriAgendaQuery();
      },
      deep: true
    }
  },
  mounted(){
    this.$store.dispatch("globalApp/setHeaderTitle", 'Manajemen Kategori Agenda');
  },
  apollo : {
    kategoriAgenda : {
      query : ALL_KATEGORI_AGENDA,
      update: data => data.kategoriAgenda,
      variables(){
        return {
          perPage: 10,
          page: this.paginationPage,
          where: {column: "NAMA", operator: "LIKE", value: `%${this.search}%`}
        }
      },
      fetchPolicy: "network",
    },
  },
  methods : {
    setUpdateItem(index){
      this.selectedUpdateItem = this.kategoriAgenda.data[index];
      this.$refs.dialogUpdate.toggleActive(true);
    },
    refetchKategoriAgendaQuery: _.debounce(function() {
      this.paginationPage = 1;
      this.$nextTick().then(() => {
        this.error = false;
        this.$apollo.queries.kategoriAgenda.refetch();
      });
    }, 300),
    handleOnReloadPage(event){
      this.paginationPage = event;
      this.$apollo.queries.kategoriAgenda.refetch();
    },
  },
};
</script>